<div class="detect-height">
  <router-outlet></router-outlet>
</div>